import React from "react";
import {Descriptions, Modal} from "antd";
import {ModalProps} from "antd/lib/modal";
import Moment from "moment";

interface SysTodoDetailProps extends ModalProps {
    record?: any
}

function SysTodoDetail(props: SysTodoDetailProps) {
    const {record, ...otherProps} = props
    return (
        <Modal {...otherProps} footer={null}>
            {record && (
                <Descriptions column={1}>
                    <Descriptions.Item label={'编号'}>{record.no}</Descriptions.Item>
                    <Descriptions.Item label={'类型'}>消息</Descriptions.Item>
                    <Descriptions.Item label={'来源'}>{record.source}</Descriptions.Item>
                    <Descriptions.Item label={'消息'}><span
                        dangerouslySetInnerHTML={{__html: record.content}}/></Descriptions.Item>
                    <Descriptions.Item label={'创建时间'}>{Moment(record.createTime).format('lll')}</Descriptions.Item>
                </Descriptions>
            )}
        </Modal>
    )
}

export default SysTodoDetail